const TOKEN_ADDRESS_PREFIX_LEN = 4;

function nonEmpty(value: unknown): string {
    return String(value ?? '').trim();
}

/** Display label: symbol → name → first chars of address + "..." */
export function resolveTokenLabel(
    tokenSymbol?: string,
    tokenName?: string,
    tokenAddress?: string,
): string {
    const symbol = nonEmpty(tokenSymbol);
    if (symbol) return symbol;

    const name = nonEmpty(tokenName);
    if (name) return name;

    const address = nonEmpty(tokenAddress);
    if (!address) return 'Unknown';

    return address.length <= TOKEN_ADDRESS_PREFIX_LEN
        ? address
        : `${address.slice(0, TOKEN_ADDRESS_PREFIX_LEN)}...`;
}
